/**
 * @desc MQ消费日志失败回调
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(body: defs.aider.ConsumeFailParamDto, options?: any) {
  return updateResponse(
    http(URL + `/log/message/consumeFail`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
